module.exports = __webpack_public_path__ + "img/fj.fjff919df.svg";